import { Link } from 'react-router-dom';

export default function CtaBanner() {
  return (
    <section className="w-full flex flex-col lg:flex-row min-h-[400px]">
      {/* Left image */}
      <div className="relative w-full lg:w-1/2 min-h-[300px] lg:min-h-[400px] overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Japanese%20cityscape%20kumamoto%20urban%20professional%20aerial%20view%20warm%20golden%20hour%20light%20modern%20city%20architecture%20strategic%20growth%20business&width=700&height=500&seq=cta-1&orientation=landscape"
          alt="東京発 全国へ"
          className="absolute inset-0 w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/50 to-transparent" />
        <div className="absolute bottom-10 left-8 md:left-14">
          <p className="text-xs tracking-[0.3em] text-[#C8501A] uppercase mb-2">Take Action</p>
          <p className="text-3xl md:text-4xl font-black text-white leading-tight">
            まずは、<br />ご相談から。
          </p>
        </div>
      </div>

      {/* Right white CTA */}
      <div className="w-full lg:w-1/2 bg-white flex flex-col justify-center items-center px-8 md:px-16 py-14">
        <div className="max-w-sm text-center">
          <p className="text-xs tracking-[0.3em] text-[#C8501A] uppercase mb-4">Free Consultation</p>
          <h3 className="text-2xl md:text-3xl font-black text-[#0A0E1A] mb-4">
            無料相談、承ります
          </h3>
          <p className="text-sm text-[#6B6560] leading-relaxed mb-8">
            事業のお悩みや課題感をお気軽にお聞かせください。
            最適なソリューションをご提案します。
          </p>
          <div className="flex flex-col gap-3">
            <Link
              to="/contact"
              className="inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-[#0A0E1A] text-white text-sm font-medium rounded-full hover:bg-[#C8501A] transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              お問い合わせフォーム <i className="ri-arrow-right-line" />
            </Link>
            <a
              href="tel:050-8896-2530"
              className="inline-flex items-center justify-center gap-2 px-8 py-3.5 border border-[#0A0E1A] text-[#0A0E1A] text-sm font-medium rounded-full hover:bg-[#0A0E1A] hover:text-white transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-phone-line" /> 050-8896-2530
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
